module.exports = __webpack_public_path__ + "img/cb9-r-1.4b708432.gif";